import {
  ServerReachabilityMonitor,
  attachReachabilityToAxios,
} from '@coachapp/connectivity';
import client from '../api/client';
import { API_URL } from '../lib/api-url';

export const reachabilityMonitor = new ServerReachabilityMonitor({
  pingIntervalMs: Number(import.meta.env.VITE_PROBE_INTERVAL_MS) || 30_000,
  pingTimeoutMs: Number(import.meta.env.VITE_PROBE_TIMEOUT_MS) || 5_000,
  getNavigatorOnline: () => (typeof navigator !== 'undefined' ? navigator.onLine : true),
  onNavigatorOnline: (cb) => {
    window.addEventListener('online', cb);
    return () => window.removeEventListener('online', cb);
  },
  onNavigatorOffline: (cb) => {
    window.addEventListener('offline', cb);
    return () => window.removeEventListener('offline', cb);
  },
  probe: async () => {
    const res = await fetch(`${API_URL}/health`, { method: 'GET', cache: 'no-store' });
    if (!res.ok) throw new Error(`health ${res.status}`);
  },
});

export function setupReachability(): () => void {
  reachabilityMonitor.start();
  const detach = attachReachabilityToAxios(client, reachabilityMonitor);
  return () => {
    detach();
    reachabilityMonitor.stop();
  };
}

export function isOffline(): boolean {
  return reachabilityMonitor.isConfirmedOffline();
}

declare global {
  interface Window {
    __coachReachability?: ServerReachabilityMonitor;
  }
}

if (import.meta.env.DEV) {
  window.__coachReachability = reachabilityMonitor;
}
